export default __webpack_public_path__ + "static/media/league_rules.d897849a.png";